
import React, { useEffect, useState } from 'react';

// internal files/dependencies
import styles from './AllTogether.module.css';
import SideBar from '../SideBar/SideBar';
import MainContent from '../MainContent/MainContent';

// mobile view components
import BottomNavMobile from '../../Components/BottomNavMobile/BottomNavMobile';

const AllTogether = ()=>{

      const [profileData, setProfileData] = useState(null);
  const [error, setError] = useState(null);
  

  useEffect(() => {
    // Reusable function to fetch protected data
    const fetchUserData = async () => {
      // 1. Grab the token we saved earlier
      const token = localStorage.getItem('token');

      try {
        // 2. Send the request with the token in the headers
        // https://madebymenow.com/pan/api/auth/
        const response = await fetch('https://madebymenow.com/pan/api/auth/person', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            // The 'Bearer ' prefix is standard practice for JWTs
            'Authorization': `Bearer ${token}` 
          }
        });

        if (!response.ok) {
          // console.error(response);
          throw new Error('Failed to fetch user data');
        }

        const data = await response.json();
        setProfileData(data); // 3. Save data to state to display it
      } catch (err) {
        setError(err.message);
      }
    };

    fetchUserData();
  }, []);






    return(
        <React.Fragment>
            <section className={styles.AllTogether_wrapper}>
            
                <p style={{width: "17%"}} className={styles.emmpty_p_tag}>&#160;</p>

                <SideBar />

                <MainContent profileData={profileData}/>

            </section>

            <BottomNavMobile />

        </React.Fragment>
    )
}

export default AllTogether;